export default __webpack_public_path__ + "images/a0b36d25fb9c9c3c5461f2ccd0b32238-literaryarts_small.webp";